exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".r-syncspicer-icon-fill {\r\n  fill: transparent;\r\n}", ""]);
